<template>
  <div class="cooperation-container">
    <div v-for="item in cooperations" v-bind:key= "item.id">
      <img v-bind:src="item.img">
    </div>
  </div>
</template>

<script>
export default {
  name: 'Cooperation',
  data: function () {
    return {
      cooperations: [
        {id: 1, img: require('../../../assets/images/sina.png')},
        {id: 2, img: require('../../../assets/images/fenghuangwang.png')},
        {id: 3, img: require('../../../assets/images/zhihuaanfang.png')},
        {id: 4, img: require('../../../assets/images/zaker.png')},
        {id: 5, img: require('../../../assets/images/netease.png')},
        {id: 6, img: require('../../../assets/images/iranshao.png')},
        {id: 7, img: require('../../../assets/images/zxhy.png')},
        {id: 8, img: require('../../../assets/images/toutiao.png')},
        {id: 9, img: require('../../../assets/images/tencent.png')}
      ]
    }
  }
}
</script>

<style scoped lang='stylus'>
  .cooperation-container
    width: 1150px
    margin: 0 auto
    display: flex
    flex-wrap: wrap
    /*grid-template-columns: 25% 25% 25% 25%*/
    /*grid-template-rows: 130px 130px 130px*/
    padding-bottom: 100px
    justify-content: space-between
    div
      text-align: center
      margin-top: 30px
      margin-left: 30px
      &:nth-child(2)
        padding-top: 20px
      &:nth-child(3)
        padding-top: 9px
      &:nth-child(4)
        padding-top: 9px
      &:nth-child(5)
        padding-top: 20px
      &:nth-child(6)
        margin-top: 0px
        padding-top: 0px
      &:nth-child(7)
        margin-top: -11px
      &:nth-child(8)
        margin-top: 50px
      &:nth-child(9)
        margin-top: 60px
</style>



// WEBPACK FOOTER //
// src/pages/example/components/Cooperation.vue